import { Injectable } from '@angular/core';
import { LocalizationService } from '@lockton-apps/shared/util/localization';
import { camelCase, get } from 'lodash';
import { StringHelpers } from '@lockton-apps/shared/util/helpers';
import { Translation } from '@lockton-apps/shared/interfaces';
import { enGb, nb } from '@lockton-apps/shared/util/constants';

@Injectable({ providedIn: 'root' })
export class ApiMessageService {
  private readonly messages = {
    enGb,
    nb,
  };

  constructor(private readonly localizationService: LocalizationService) {}

  translate(translation: Translation): string {
    const locale: string = this.localizationService.getLocalePreference();
    const message: string = get(
      get(this.messages, [camelCase(locale), 'translations']),
      translation.key,
      translation.key
    );

    return StringHelpers.interpolate(message, translation.args);
  }
}
